import type { HTTPCronJob, CronJobFilterStatus } from '../../../../apps/hooks/system/useCronJob';
import type { HTTPMethod } from '../../../../models/CronJob';
import { CronJobStatus } from '../../../../models/CronJob';

export enum CronJobType {
  HTTP = 'HTTP',
}

export interface CronJobListProps {
  cronJobs: HTTPCronJob[];
  onView: (cronJob: HTTPCronJob) => void;
  onEdit: (cronJob: HTTPCronJob) => void;
  onDelete: (cronJob: HTTPCronJob) => void;
  onStatusChange: (cronJob: HTTPCronJob, status: CronJobStatus) => void;
  loading?: boolean;
}

export interface CronJobFiltersProps {
  selectedStatus: CronJobFilterStatus;
  onStatusChange: (status: CronJobFilterStatus) => void;
  totalCronJobs: number;
}

export interface CronJobDetailModalProps {
  show: boolean;
  cronJob: HTTPCronJob | null;
  onHide: () => void;
  onEdit: () => void;
}

export interface CreateCronJobModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (formData: FormData) => void;
  isSubmitting?: boolean;
}

export interface UpdateCronJobModalProps {
  show: boolean;
  cronJob: HTTPCronJob | null;
  onHide: () => void;
  onSubmit: (formData: FormData) => void;
  isSubmitting?: boolean;
}

export interface DeleteCronJobModalProps {
  show: boolean;
  cronJob: HTTPCronJob | null;
  onHide: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export interface FormData {
  name: string;
  cronExpression: string;
  isOneTime: boolean;
  scheduledDateTime: string;
  status: CronJobStatus;
  cronJobType: CronJobType;
  url: string;
  method: HTTPMethod;
  headers: Record<string, string>;
  body: string;
}

export const getCronJobStatusColor = (status: CronJobStatus): string => {
  switch (status) {
    case CronJobStatus.ENABLED:
      return 'success';
    case CronJobStatus.DISABLED:
      return 'secondary';
    default:
      return 'secondary';
  }
};

export const getCronJobStatusText = (status: CronJobStatus): string => {
  switch (status) {
    case CronJobStatus.ENABLED:
      return 'Enabled';
    case CronJobStatus.DISABLED:
      return 'Disabled';
    default:
      return 'Unknown';
  }
};
